import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import MotionDiv from "../motionDiv";
import {Col, Row} from "react-bootstrap";
import {Link} from "react-router-dom";

function FormationBlock() {

    return (
            <section id="formation" className="about-section-two style-two layout-pt-60 layout-pb-60 js-tab-menu-content">
                <div className="auto-container">
                    <Row>
                        <Col lg={6} md={6} sm={12}>
                            <MotionDiv>
                                <div className="sec-title">
                                    <h2>
                                        Talents Handicap <span className="formation-title">Formation</span>
                                    </h2>
                                    <h3>Former et sensibiliser au handicap et à l’inclusion</h3>
                                </div>
                            </MotionDiv>
                            <MotionDiv delay={0.3}>
                                <div className="text mt-30">
                                    <p>
                                        Talents Handicap Formation est la solution pour <span>former et sensibiliser</span> de manière
                                        flexible et concrète <span>l'ensemble de vos acteurs et collaborateurs </span>: managers,
                                        dirigeants, recruteurs, référents handicap, mission handicap, équipes ressources
                                        humaines (RH), instances représentatives du personnel (IRP), équipes
                                        Communication, RSE…
                                        <br/>
                                        <br/>
                                        <span>A distance ou en présentie</span>l, bénéficiez de formations personnalisées qui  facilitent
                                        la participation et l’engagement de vos acteurs. Elles leur permettent de <span>déconstruire
                                        leurs préjugés</span> et de <span>développer leurs compétences inclusives</span>, plus particulièrement en recrutement,
                                        accueil, intégration, accompagnement, management, maintien dans l'emploi des collaborateurs
                                        en situation de handicap, handicap invisible, neurodiversité, santé mentale…
                                        <br/>
                                        <br/>
                                        Talents Handicap Formation <span>contribue également au financement de vos actions de recrutement
                                        et d’emploi</span> de talents en situation de handicap.
                                        <br/>
                                        <br/>
                                        Nous sommes <span>certifiés Qualiopi</span> pour nos actions de formation, avec une équipe
                                        disposant d’une forte expertise terrain du handicap au travail, capable d’intervenir partout en France.
                                        <br/>
                                        <br/>
                                        Nos clients nous disent que nos formations créent de l’impact et de l’engagement
                                        dans leur organisation. <b>Faites comme eux !</b> <span>Rejoignez-nous !</span>
                                    </p>
                                    <div className={'d-flex justify-content-center justify-content-sm-start'}>
                                        <Link to="https://formation.talents-handicap.com/"
                                              target="_blank"
                                              className="theme-btn btn-style-one btn-formation mt-3 mb-3 small">
                                            Explorer Talents Handicap Formation
                                        </Link>
                                    </div>
                                </div>
                            </MotionDiv>
                        </Col>

                        <Col lg={6} md={6} sm={12} className="mt-lg-0 mt-md-0 mt-sm-5">
                            <MotionDiv delay={0.5} classes={''}>
                                <figure className="section-picture">
                                    <img className="photo" src="/images/homepage/atelier-sensibilisation-handicap-entreprise.webp"
                                         alt="Collaborateurs participant à un atelier sensibilisation handicap entreprise"
                                         width={628} height={812}
                                    />
                                    <div className="section-picture-qualiopi">
                                        <a href={"https://gestion.talentshandicap-formation.fr/uploads/certificat/Certificate%20-%2021106298%20-%20NEW%20NET%203D.pdf"}
                                           target={"_blank"}>
                                            <img src="/images/homepage/qualiopi.png"
                                             alt="Qualiopi"
                                             width={251}
                                             height={134}/>
                                        </a>
                                        <p>
                                            La certification qualité a été délivrée au titre de la catégorie d'action suivante :
                                            <br/>
                                            <strong>ACTION DE FORMATION</strong>
                                        </p>
                                    </div>
                                </figure>
                            </MotionDiv>
                        </Col>
                    </Row>
                </div>
            </section>
    )
}

export default FormationBlock;
